import React from "react";

export const SlideContext = React.createContext({
  slideNum: 0,
  setSlideNumber: (number) => {},
  setWheelListener: (ref, slideNum) => {},
});